var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6024_17861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.19401 12.8487C14.7162 6.38053 25.2941 6.38053 31.8163 12.8487L32.6006 13.6219C32.9309 13.9458 32.9309 14.4683 32.6006 14.7922L29.9174 17.4568C29.7523 17.6135 29.4943 17.6135 29.3292 17.4568L28.2456 16.3805C23.6945 11.8664 16.3158 11.8664 11.7647 16.3805L10.6089 17.53C10.4438 17.6867 10.1858 17.6867 10.0206 17.53L7.32714 14.8758C6.9969 14.5519 6.9969 14.0294 7.32714 13.7055L8.19401 12.8487ZM37.3684 18.3554L39.7626 20.7274C40.0929 21.0514 40.0929 21.5738 39.7626 21.8978L28.9783 32.5874C28.6481 32.9114 28.1218 32.9114 27.8019 32.5874L20.1548 25.0012C20.0722 24.9176 19.9381 24.9176 19.8555 25.0012L12.2085 32.5874C11.8782 32.9114 11.3519 32.9114 11.032 32.5874L0.247678 21.8978C-0.0825593 21.5738 -0.0825593 21.0514 0.247678 20.7274L2.6419 18.3554C2.97214 18.0315 3.49845 18.0315 3.81837 18.3554L11.4654 25.9417C11.548 26.0252 11.6821 26.0252 11.7647 25.9417L19.4118 18.3554C19.742 18.0315 20.2683 18.0315 20.5882 18.3554L28.2353 25.9417C28.3179 26.0252 28.452 26.0252 28.5346 25.9417L36.1816 18.3554C36.5119 18.0315 37.0382 18.0315 37.3684 18.3554Z",
    fill: "#3B99FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6024_17861"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletconnect);
export default __webpack_public_path__ + "static/media/walletconnect.445c66d6fdf1b4872ad34177ba58a11e.svg";
export { ForwardRef as ReactComponent };